<h1 mat-dialog-title>{{ isOwner ? 'Manage Team Users' : 'Add User' }}</h1>
<div mat-dialog-content>
  <div *ngIf="isOwner">
    <div *ngIf="teamGroupMembers.length">
      <h2>Current Team Members</h2>
      <ul class="member-list">
        <li class="member-container" *ngFor="let member of teamGroupMembers">
          <span>{{ member.displayName }} ({{ member.email }})</span>
          <div class="add-promote-users-buttons">
            <button
              mat-button
              class="secondary-action-button"
              color="warn"
              [attr.aria-label]="'Remove user ' + member.displayName"
              (click)="removeGroupMember(member.email, member.displayName, true)">
              Remove User
            </button>
            <button
              mat-button
              class="primary-action-button"
              color="primary"
              [attr.aria-label]="'Promote ' + member.displayName + ' to owner'"
              (click)="promoteGroupMember(member.email, member.displayName)">
              Promote to Owner
            </button>
          </div>
        </li>
      </ul>
    </div>
    <hr />
  </div>
  <h2>Add Users to the Team</h2>
  <form [formGroup]="userForm">
    <fieldset formArrayName="users">
      <legend class="visually-hidden">User email addresses</legend>
      <div *ngFor="let _ of userControls; let i = index" [formGroupName]="i">
        <mat-form-field>
          <mat-label>Email address for user {{ i + 1 }}</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            [attr.aria-label]="'Email address for user ' + (i + 1)" />
          <button
            mat-icon-button
            matSuffix
            *ngIf="userControls.length > 1"
            [attr.aria-label]="'Remove email entry ' + (i + 1)"
            (click)="removeUser(i)">
            <mat-icon aria-hidden="true">remove_circle</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </fieldset>
    <button mat-button class="primary-action-button" aria-label="Add another user email field" (click)="addUser()">
      Add Another User
    </button>
  </form>
</div>
<div mat-dialog-actions>
  <div *ngIf="!teamGroupMembers?.length">
    <button
      mat-button
      class="secondary-action-button"
      color="warn"
      [attr.aria-label]="'Close team ' + teamName"
      (click)="closeTeam(teamName)">
      Close the Team
    </button>
  </div>
  <button mat-button class="secondary-action-button" aria-label="Cancel and close dialog" (click)="onCancel()">
    Cancel
  </button>
  <button
    mat-button
    [ngClass]="{ 'primary-disabled-action-button': isDisabled(), 'primary-action-button': !isDisabled() }"
    [disabled]="isDisabled()"
    [attr.aria-disabled]="isDisabled()"
    aria-label="Submit user changes"
    (click)="onSubmit()">
    Submit
  </button>
</div>
